<template>


    <v-container>
        <v-form
                v-model="valid"
                class="mb-12"
        >

            <v-row>
                <v-col align="center">
                    <Logo class="mb-10"/>
                    <h5 class="headline mb-4">
                        <Dictionary v-if="!passwordSent" module="forgotPassword" string="title"/>
                        <Dictionary v-else module="checkEmail" string="title"/>
                    </h5>
                    <p>
                        <Dictionary v-if="!passwordSent" module="forgotPassword" string="subtitle"/>
                        <Dictionary v-else module="checkEmail" string="subtitle"/>
                    </p>
                </v-col>
            </v-row>


            <v-row>
                <v-col align="center">

                    <UsernameInput
                            v-if="!passwordSent"
                            v-model="username"
                            :rules="emailRules"
                            required>

                    </UsernameInput>
                    <Button
                            v-if="!passwordSent"
                            :disabled="!valid"
                            block
                            @click.prevent="send()"
                            :loading="loading"
                    >
                        <Dictionary module="forgotPassword" string="reset_password_button_prompt" />
                    </Button>

                    <Button class="ma-3"
                            block
                            v-else
                            @click.prevent="updatePasswordSent()"
                            ghost
                    >
                        <Dictionary module="forgotPassword" string="problem_receiving_email_button_prompt" />
                    </Button>
                    <Button class="ma-3"
                            v-if="passwordSent"
                            block
                            @click="continueButton()"
                    >
                        <Dictionary module="default" string="continue_button_prompt" />
                    </Button>
                </v-col>
            </v-row>
        </v-form>
    </v-container>


</template>


<script>


import Vue from 'vue';
import { mapGetters } from 'vuex';
import { emailValueRequiredRule, emailValidRule } from '../../helpers/rules/email';


export default Vue.extend({
  name: 'ForgotPassword',
  data() {
    return {
      valid: true,
      username: '',
      loading: false,
      emailRules: [
        emailValidRule,
        emailValueRequiredRule,
      ],

    };
  },
  methods: {
    async send() {
      this.loading = true;
      const data = {
        username: this.username,
      };
      const response = await this.$store.dispatch('REQUEST_PASSWORD_RESET', data);
      if (response.code !== 201) {
        this.loading = false;
      }
      this.loading = false;
    },
    updatePasswordSent() {
      this.$store.commit('UPDATE_PASSWORD_EMAIL_NOT_SENT');
    },
    continueButton() {
      // this.$router.push({ name: 'ResetPassword', params: { resetKey: 'abcdef' }, query: { email: 'dev@class4kids.co.uk' } });
      // this.$router.push({ name: 'ResetPassword' });
      this.$router.push({ name: 'LoginPage' });
    },
  },

  computed: {
    ...mapGetters(['loginData', 'passwordSent']),
  },

  created() {
    this.username = this.$route.params.username;
  },

  mounted() {
  },
  components: {

  },
});
</script>


<style scoped>

</style>
